export default {
  feedback: {
    token_required: 'Te rugăm să bifezi căsuța pentru a confirma că ești om',
    frequent_requests:
      'Verifică SMS-ul. Am trimis deja codul la numărul indicat prin SMS. Dacă nu l-ai primit, verifică numărul de telefon sau încearcă din nou în 10 minute.',
  },
};
